import { render, staticRenderFns } from "./ToolPanelLabel.vue?vue&type=template&id=9b7407e4&scoped=true&"
import script from "./ToolPanelLabel.vue?vue&type=script&lang=js&"
export * from "./ToolPanelLabel.vue?vue&type=script&lang=js&"
import style0 from "./ToolPanelLabel.vue?vue&type=style&index=0&id=9b7407e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7407e4",
  null
  
)

export default component.exports